// extracted by mini-css-extract-plugin
module.exports = {"unlimitedClasses":"AddEditMembershipPlan_unlimitedClasses__3TVGg"};